<template>
  <div style="padding: 0px 22px;" v-if="props.showTempDown!==false">
    <div class="excel-tip-template">
      <i class="" style="width: 16px; height: 16px; line-height: 16px; font-size: 16px;"></i>
      为了保证数据导入顺利，推荐您下载使用 <span class="remix-icon  ri-tuichu"></span>
      <span @click="downExcel" class="common-link">导入模版</span>，并按照规范示例录入数据。
    </div>

  </div>


  <div  style="padding: 22px;margin-top: 0px;padding-bottom: 40px;color:#888;">
    <div style="padding: 12px 0;color:#444;">上传的 Excel 表符合以下规范：</div>
    <ul style="color:#777;font-size: 12px;">
      <li>• 文件大小不超过10M，且单个sheet页数据量不超过5000行。当触发校验规则、关联业务规则和第三方服务回调时，单个sheet页数据量不超过 5000 行</li>
      <li>• 仅支持 (*.xls 和 *.xlsx)文件</li>
      <li>• 请确保您需要导入的sheet表头中不包含空的单元格，否则该sheet页数据系统将不做导入</li>
      <li>• 批量导入的数据不支持以“内置变量”作为条件的过滤</li>
      <li>• 导入文件不支持Excel公式计算，如SUM，=H2*J2等</li>
      <li>• 目前导入图片/附件会转存，占用一定附件容量</li>
    </ul>

  </div>


</template>


<script lang="ts">
import {defineComponent} from 'vue';


export default defineComponent({
  name: 'import-win-modal',
});
</script>

<script lang="ts" setup>
import {QueryCommand} from "xmgoing-server";
import {useI18n} from "vue-i18n";

const {t} = useI18n();


interface propsType{
  props:any;
}
const propsDef = withDefaults(defineProps<propsType>(),{
  props:{}
});
const {props}=toRefs(propsDef);

const downExcel=function (){
  const queryCommand = new QueryCommand({showTip:false});
  queryCommand.executeExport(
      unref(props).downUrl||`/api/go-lcc/execute/exportTemplateByTableCode/`+unref(props).tableCode,
      (unref(props).fileName||'导入模版')+'.xlsx',
      {}
  );
}

</script>

<style lang="less">
.xm-char-data-config{
  .ant-modal-body{
    padding: 0;
  }
}
</style>
